<script>
    export default {
        props: {
            total: {
                type: Array
            }
        }
    };
</script>


<template>
    <v-card v-if='total' class='fluid__card--total'>
        <span class='fluid__card--total__title'>Totais</span>

        <div style='fluid__card__container'>
            <span class='fluid__card--total__q'>{{ total[0] }}</span>
            <span class='fluid__card--total__v' style>{{ total[1] }}</span>
        </div>
    </v-card>
</template>

<style scoped>
    i {
        margin-right: 5px;
    }

    .fluid__card--total {
        display: flex;
        position: relative;
        padding: 15px;
        margin-top: 10px;
        margin-bottom: 10px;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }

    .fluid__card--total__title {
        font-weight: 700;
        display: flex;
        align-items: center;
        font-size: 1.2rem;
    }

    .fluid__card__container {
        flex-wrap: wrap;
        display: flex;
        flex: 1;
        justify-content: flex-end;
        align-items: center;
    }

    .fluid__card--total__q,
    .fluid__card--total__v {
        margin-left: 10px;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 1.2rem;
    }
</style>
